import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Company } from './company.service';

/**
 * The company currently open in the company detail shell.
 *
 * Child tabs need the company's name and timezone (impersonation stamps both onto
 * the session) but should not each refetch it. The shell resolves the company from
 * the route param and publishes it here.
 */
@Injectable({
  providedIn: 'root',
})
export class CompanyContextService {
  private readonly company$ = new BehaviorSubject<Company | null>(null);

  readonly current$: Observable<Company | null> = this.company$.asObservable();

  get current(): Company | null {
    return this.company$.value;
  }

  get name(): string {
    return this.company$.value?.name || '';
  }

  get timezone(): string | undefined {
    return this.company$.value?.timezone;
  }

  set(company: Company | null): void {
    this.company$.next(company);
  }

  clear(): void {
    this.company$.next(null);
  }
}
